module.exports = __webpack_public_path__ + "img/20m-sprint.10ace1c8.png";